(function (angular, app) {
   "use strict";

   app.modules.scoring = {
      name: "app.Scoring"
      , constants: {
         holesPlayed : {
             eighteenHoles : "EighteenHoles"
             , frontNine: "FrontNine"
            , backNine: "BackNine"
         }
         , scoreType: {
            away : "Away"
            , combined : "Combined"
            , penalty : "Penalty"
            , tournament:  "Tournament"
            , awayTournament : "AwayTournament"
         }
         , fairwayHitType: {
            noOpportunity : "NoOpportunity"
            , hit : "Hit"
            , missed : "MissedUnspecified"
            , missedLong : "MissedLong"
            , missedShort : "MissedShort"
            , missedLeft : "MissedLeft"
            , missedRight : "MissedRight"
         }
      }
      , controllers : {
      }
      , decorators : {
      }
      , directives : {
         fir : "ggFirDirective"
         , updown : "ggUpDownDirective"
         , sandie : "ggSandieDirective"
         , club: "ggClubDirective"
         , leaderboard : "ggLeaderboardDirective"
      }
      , objects: {
         gameHoleScore: function(){
            //this.id = null;
            this.holeNumber = null;
            this.gross = null;
            this.gameScoreId = null;
            this.strokes = 0;
            this.strokesGained = [];
            this.stats = {
               puttCount: null
               , puttLength: null
               , gir: null
               , driveDistance: null
               , fir: null
               , fairwayChips: null
               , greensideChips: null
               , upAndDownOpportunity: null
               , upAndDownHit: null
               , sandSaveOpportunity: null
               , sandSaveHit: null
               , bounceBackOpportunity: null
               , bounceBackHit: null
               , scrambleOpportunity: null
               , scrambleHit: null
               , callawayScore: null
               , penaltyStrokes: null
               , golfClub : null
            }
            this.wagers = {
                value1: null
               , value2: null
               , value3: null
               , value4 : null
               , value5: null
            }
            this.Temp = {};
         }
         , scoreStats: function () {

            this.puttCount = null;
            this.shortestOnePutt = null;
            this.longestOnePutt = null
            this.gir = null;
            this.longDriveDistance = null
            this.avgDriveDistance = null;
            this.fairwayOpportunities = null;
            this.fairwaysHit = null;
            this.fairwaysMissed = null;
            this.fairwaysMissedLeft = null;
            this.fairwaysMissedRight = null;
            this.fairwaysMissedLong = null;
            this.fairwaysMissedShort = null;
            this.fairwayChips = null;
            this.greensideChips = null;
            this.upAndDownOpportunities = null;
            this.upAndDownsHit = null;
            this.sandSaveOpportunities = null
            this.sandSavesHit = null;
            this.bounceBackOpportunities = null
            this.bounceBacksHit = null;
            this.scrambleOpportunities = null;
            this.scramblesHit = null;
            this.callawayScore = null;
            this.callawayHandicap = null;
            this.holeInOneCount = null;
            this.albatrossCount = null;

            this.eagleCount = null;
            this.birdieCount = null;
            this.parCount = null;
            this.bogeyCount = null;
            this.doubleCount = null;
            this.overDoubleCount = null;

            this.par3Count = null;
            this.par4Count = null;
            this.par5Count = null;
            this.par3Score = null;
            this.par4Score = null;
            this.par5Score = null;
            this.penaltyStrokes = null;
            this.exceptionalScoreOdds = null;
         }
         , holeScore: function () {
            this.number = null
            this.gross = null
            this.esc = null
            this.par = null
            this.strokesGained = [],
            this.stats = {
               puttCount: null
               , puttLength: null
               , gir: null
               , driveDistance: null
               , fir: null
               , fairwayChips: null
               , greensideChips: null
               , upAndDownOpportunity: null
               , upAndDownHit: null
               , sandSaveOpportunity: null
               , sandSaveHit: null
               , bounceBackOpportunity: null
               , bounceBackHit: null
               , scrambleOpportunity: null
               , scrambleHit: null
               , callawayScore: null
               , penaltyStrokes: null
               , golfClub : null

            }
         }
      }

      , filters: {
      }
      , services : {
         scorecard: "ggScoreCardService"
         , gamescore: "ggGameScoreFactory"
         , score: "ggScoreFactory"
      }
      , routes : {
          postaround : {
             path: "/scoring/postaround"
               , controller : "gg_PostARoundController"
               , controllerAs : "ggPostARoundCtrl"
               , templateUrl : "app/scoring/controllers/postaround.html"
               , features : {
                        showHeading : true
               }
            , accessControl : {
                  roles: ["AUTHENTICATED"]
                  , roleCheckType : 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
         , postascore: {
             path: "/scoring/postascore"
            , controller: "gg_PostAScoreController"
            , controllerAs: "ggPostAScoreCtrl"
            , templateUrl: "app/scoring/controllers/postascore.html"
            , features: {
                showHeading: true
            }
            , accessControl: {
                roles: ["AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
         }
          , scoredetail: {
              path: "/scoring/score"
            , controller: "gg_ScoreDetailController"
            , controllerAs: "ggScoreDetailCtrl"
            , templateUrl: "app/scoring/controllers/score-detail.html"
            , features: {
                showHeading: true
            }
            , accessControl: {
                roles: ["AUTHENTICATED"]
                , roleCheckType: 1 //app.modules.core.types.roleCheckType.atLeastOne
            }
          }
         , gameholeview: {
            controller: "gg_GameHoleViewController"
            , templateUrl: "app/scoring/controllers/holeview-game.html"
         }
         , scoreholeview: {
            controller: "gg_ScoreHoleViewController"
            , templateUrl: "app/scoring/controllers/holeview-score.html"
         }
      }
      , functions: {
         fetchCallawayHandicap: function (par, score) {
            var rv = 0;
            var adj = par - 72;
            
            if (score > (72+adj) && score < (76+adj)) {
               rv = 5;
            }
            if (score > (75+adj) && score < (81+adj)) {
               rv = 10;
            }
            if (score > (80+adj) && score < (86+adj)) {
               rv = 15;
            }
            if (score > (85+adj) && score < (91+adj)) {
               rv = 20;
            }
            if (score > (90+adj) && score < (96+adj)) {
               rv = 25;
            }
            if (score > (95+adj) && score < (101+adj)) {
               rv = 30;
            }
            if (score > (100+adj) && score < (106+adj)) {
               rv = 35;
            }
            if (score > (105+adj) && score < (111+adj)) {
               rv = 40;
            }
            if (score > (110+adj) && score < (116+adj)) {
               rv = 45;
            }
            if (score > (115+adj) && score < (121+adj)) {
               rv = 5.0;
            }
            if (score > (120+adj) && score < (126+adj)) {
               rv = 55;
            }
            if (score > (125 + adj) && score < (131 + adj)) {
               rv = 60;
            }
            if (score > (130+adj) && score < (136+adj)) {
               rv = 65;
            }
            if (score > (135+adj) && score < (141+adj)) {
               rv = 70;
            }
            if (score > (140+adj) && score < (146+adj)) {
               rv = 75;
            }
            
            return rv;
         }
         , 
         fetchCallawayAdjustment: function (par, score) {
            var rv = 0;
            var adj = par - 72;

            if ([73 + adj, 76 + adj, 81 + adj, 86 + adj, 91 + adj, 96 + adj, 101 + adj, 106 + adj, 111 + adj, 116 + adj, 121 + adj, 126 + adj].indexOf(score) > 0) {
               rv = -2;
            }
            if ([74 + adj, 77 + adj, 82 + adj, 87 + adj, 92 + adj, 97 + adj, 102 + adj, 107 + adj, 112 + adj, 117 + adj, 122 + adj, 127 + adj].indexOf(score) > 0) {
               rv = -1;
            }
            if ([75 + adj, 78 + adj, 83 + adj, 88 + adj, 93 + adj, 98 + adj, 103 + adj, 108 + adj, 113 + adj, 118 + adj, 123 + adj, 128 + adj].indexOf(score) > 0) {
               rv = 0;
            }
            if ([79 + adj, 84 + adj, 89 + adj, 94 + adj, 99 + adj, 104 + adj, 109 + adj, 114 + adj, 119 + adj, 124 + adj, 129 + adj].indexOf(score) > 0) {
               rv = 1;
            }
            if ([80 + adj, 85 + adj, 90 + adj, 95 + adj, 100 + adj, 105 + adj, 110 + adj, 115 + adj, 120 + adj, 125 + adj, 130 + adj].indexOf(score) > 0) {
               rv = 1;
            }
            return rv;
         }
      }
   };
   
   angular.module(app.modules.scoring.name, []);

}(angular, app));
